import type { WaitingUserInfo } from 'api/types';
import { VCS_DISMISSED_WAITING_SET_KEY } from 'consts';
import { dismissBannerForWaitingIds, isWaitingBannerDismissed } from './waitingListRegistry';

let dismissedWaitingSetKey: string | null = null;

try {
    dismissedWaitingSetKey = sessionStorage.getItem(VCS_DISMISSED_WAITING_SET_KEY);
} catch {
    // ignore
}

export const getWaitingUsersSetKey = (users: Pick<WaitingUserInfo, 'userId' | 'waitingListId'>[]): string =>
    [...users]
        .map((user) => user.userId ?? user.waitingListId)
        .sort()
        .join('|');

const persistDismissedWaitingSet = (): void => {
    try {
        if (dismissedWaitingSetKey) {
            sessionStorage.setItem(VCS_DISMISSED_WAITING_SET_KEY, dismissedWaitingSetKey);
        } else {
            sessionStorage.removeItem(VCS_DISMISSED_WAITING_SET_KEY);
        }
    } catch {
        // ignore
    }
};

/** Закрытие баннера крестиком: не показывать снова, пока не изменится набор стучащихся. */
export const dismissBannerForWaitingUsers = (users: WaitingUserInfo[]): void => {
    if (users.length === 0) {
        return;
    }
    dismissedWaitingSetKey = getWaitingUsersSetKey(users);
    persistDismissedWaitingSet();
    dismissBannerForWaitingIds(users.map((user) => user.waitingListId));
};

const isWaitingBannerDismissedForUsers = (users: WaitingUserInfo[]): boolean => {
    if (users.length === 0) {
        return false;
    }
    const currentSetKey = getWaitingUsersSetKey(users);
    if (dismissedWaitingSetKey && dismissedWaitingSetKey === currentSetKey) {
        return true;
    }
    return users.every((user) => isWaitingBannerDismissed(user.waitingListId));
};

export const shouldShowWaitingRequestsBanner = (users: WaitingUserInfo[]): boolean =>
    users.length > 0 && !isWaitingBannerDismissedForUsers(users);

export const clearWaitingBannerDismissState = (): void => {
    dismissedWaitingSetKey = null;
    try {
        sessionStorage.removeItem(VCS_DISMISSED_WAITING_SET_KEY);
    } catch {
        // ignore
    }
};
